ACC.checkoutsteps = {

    _autoload: [
        'permeateLinks',
    ],

    changeLocation(e) {
        e.preventDefault();
        const link = $(this).closest('a').attr('href');

        if (link) {
            window.location = link;
        }
    },

    permeateLinks() {
        const step = document.querySelectorAll('.step-head');
        let number = 0;

        $(document).on('click', '.js-checkout-step', ACC.checkoutsteps.changeLocation);

        [].forEach.call(step, (event) => {
            number += 1;
            event.setAttribute('checkout', number);
        });
    },
};
